/**
 * `useRouteWithToken` navigates to `/route/?linkId=…`. React Router keeps
 * the trailing slash on `location.pathname` (`/cash-stores-page/`). Route
 * constants have no slash — compare only after stripping it.
 */
export function normalizeRoutePath(path: string): string {
  if (path.length > 1 && path.endsWith("/")) return path.slice(0, -1);
  return path;
}
